// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__3kXjy","insightsList":"newBusinessInsightsMenu_insightsList__2roDi","active":"newBusinessInsightsMenu_active__15S0u"};